




























































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  IRouteCity,
  IRouteInfo,
  IFullRoute,
} from "@/@types/routeInfo/route-info";

@Component({})
export default class RouteListCitysDataTable extends Vue {
  @Prop({ type: Object, default: null }) route!: IRouteInfo;
  @Prop({ type: Array, default: () => [] }) cityList!: Array<IRouteCity>;

  chngeArrival: IFullRoute | null = null;
  chngeDeparture: IFullRoute | null = null;
  arrival = "";
  departure = "";

  getCity(code: string): Partial<IRouteCity> {
    for (const city of this.cityList) {
      if (city.code == code || code == city._id) {
        return city;
      }
    }
    return {};
  }

  changeDateTime(): void {
    if ((!this.chngeArrival && !this.chngeDeparture) || !this.route.full_route)
      return;
    const code = this.chngeArrival
      ? this.chngeArrival.code
      : this.chngeDeparture
      ? this.chngeDeparture.code
      : null;
    if (!code) return;

    const routeChange: IFullRoute = {
      code: code,
      arrival: this.chngeArrival
        ? this.chngeArrival.arrival
        : this.chngeDeparture
        ? this.chngeDeparture.arrival
        : "",
      departure: this.chngeArrival
        ? this.chngeArrival.departure
        : this.chngeDeparture
        ? this.chngeDeparture.departure
        : "",
      force_arrival: this.arrival
        ? this.arrival
        : this.chngeArrival
        ? ""
        : this.chngeDeparture
        ? this.chngeDeparture.force_arrival
        : "",
      force_departure: this.departure
        ? this.departure
        : this.chngeArrival
        ? this.chngeArrival.force_departure
        : "",
    };
    const full_route: Array<IFullRoute> | undefined = this.route.full_route;
    for (const city of full_route) {
      if (
        city.code == code &&
        (city.arrival == routeChange.arrival || routeChange.departure)
      ) {
        city.force_departure = routeChange.force_departure;
        city.force_arrival = routeChange.force_arrival;
        break;
      }
    }
    this.$emit("changeRoute", this.route._id, { full_route });

    this.chngeArrival = null;
    this.chngeDeparture = null;
    this.arrival = "";
    this.departure = "";
  }
}
